module.exports = __webpack_public_path__ + "static/TheoryChange-be922718bbb8953f07172b0b7b57ec8c.jpg";